import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const SCHEMA_SELECTORS_QUERY = gql`
  query SchemaSelectorsQuery($includeArchived: StrictBoolean!) @skipAudit @engComponent(name: INVENTORY) {
    schemaFieldSelectors(includeArchived: $includeArchived) {
      ...SchemaFieldSelectorGraphQL
    }
  }
  ${getFragmentWrapper('SchemaFieldSelector').fragment}
`;

export const CONTAINER_SCHEMA_QUERY = gql`
  query ContainerSchemaQuery($storableSchemaId: StrictString!) @skipAudit @engComponent(name: INVENTORY) {
    storableSchema(id: $storableSchemaId) {
      ... on ContainerSchemaNode {
        id
        fieldsJson
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const REAGENT_SCHEMAS_QUERY = gql`
  query ReagentSchemasQuery($storableSchemaIds: [StrictString!]!, $tagSchemaIds: [StrictString!]!)
  @skipAudit
  @engComponent(name: INVENTORY) {
    storableSchemas(ids: $storableSchemaIds) {
      ... on ContainerSchemaNode {
        id
        iconId
        name
      }
      ...InaccessibleInfoGraphQL
    }
    tagSchemaChips(ids: $tagSchemaIds) {
      ...TagSchemaChipOrInaccessibleGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${getFragmentWrapper('TagSchemaChipOrInaccessible').fragment}
`;
